import { useEffect, useState } from 'react';
import { useGetContainer } from 'api/container';
import { Container, GetContainerParams } from 'api/container/container.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function ContainerTypeAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getContainer } = useGetContainer();
  const [options, setOptions] = useState<Container[]>([]);
  const [containerParams, setContainerParams] = useState<GetContainerParams>({
    filterText: '',
    pageNumber: 1,
  });

  useEffect(() => {
    getContainer(containerParams);
  }, [getContainer, containerParams]);

  useEffect(() => {
    if (data?.length) {
      const fetchedOptions = data.map((container) => ({
        id: container.id,
        code: container.code,
        enabled: container.enabled,
      }));
      const filteredOptions = fetchedOptions.filter(
        (activity) => activity.enabled,
      );
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [data]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => o.code}
      handleSearchChange={handleChange(setOptions, setContainerParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setContainerParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setContainerParams,
        formProps.field.onBlur,
      )}
    />
  );
}
